import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76794aa6")

_pushScopeId("data-v-76794aa6")
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "User Preferences", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", null, "Display Preferences", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Metric ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Imperial ")
const _hoisted_6 = { class: "buttons-container" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Save")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.form,
        ref: "formRef",
        "status-icon": "",
        "label-width": "200px"
      }, {
        default: _withId(() => [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_el_form_item, {
            label: "System of Measurement",
            prop: "systemOfMeasurement",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.form.systemOfMeasurement,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.systemOfMeasurement = $event)),
                disabled: !_ctx.canEdit
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, { label: "metric" }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: "imperial" }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Time Zone (UTC offset)",
            prop: "timezone",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.timezone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.timezone = $event)),
                disabled: !_ctx.canEdit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_6, [
                _withDirectives(_createVNode(_component_el_button, {
                  onClick: _ctx.saveUser,
                  type: "primary",
                  disabled: !_ctx.canEdit
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]), [
                  [_directive_loading, _ctx.saveState === _ctx.FetchStates.FETCHING]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]), [
        [_directive_loading, _ctx.fetchState !== _ctx.FetchStates.FETCHED]
      ])
    ])
  ]))
})